import { SysOption } from 'bff/models/info';
import { SYSTEM_FETCH_URL_SYS_OPTS, SYSTEM_SAVE_URL_SYS_OPTS, SystemActions } from './types';

/**
 * @description 取得系統參數 Url
 */
export const fetchUrlSysOptsAction = (onComplete?: () => Promise<void>): SystemActions => ({
  type: SYSTEM_FETCH_URL_SYS_OPTS,
  payload: { onComplete }
});

/**
 * @description 緩存系統參數 Url
 * @param data 系統參數 Url
 */
export const saveUrlSysOptsAction = (data: SysOption[]): SystemActions => ({
  type: SYSTEM_SAVE_URL_SYS_OPTS,
  payload: { data }
});
